export enum DocumentTypeEnum {
COTIZACION = "DT001",
PEDIDO = "DT002",
DOCUMENTO_DE_CARGA = "DT003",   
ENTREGA_ENTRADA = "DT004",
FACTURA = "DT005",
NOTA_DE_CREDITO = "DT006",
NOTA_DE_DEBITO = "DT007",
DOCUMENTO_DE_PAGO = 'DT008',
SOLICITUD_CAMBIO_PRODUCTO = "DT009",
SOLICITUD_DEVOLUCION_PRODUCTO = "DT010",
ENTREGA_SALIDA = "DT011",
CAMBIO_DE_PRODUCTO = "DT012",
DEVOLUCION_DE_PRODUCTO = "DT013",
DOCUMENTO_DE_TRANSPORTE = "DT014",
PEDIDO_DE_VENDEDOR = "DT015",
LIQUIDACION = "DT016",
DOCUMENTO_MERMA = "DT017"
}



export const DOCUMENT_TYPES_WORK_IN_PROGRESS_TRIPS_SECTION = [
    DocumentTypeEnum.ENTREGA_SALIDA,
    DocumentTypeEnum.FACTURA,
    DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO,
    DocumentTypeEnum.PEDIDO,
    DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO,
    DocumentTypeEnum.DOCUMENTO_MERMA,
    DocumentTypeEnum.CAMBIO_DE_PRODUCTO,
    DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO,
];

export const EXPORT_BATCHES_GROUPED_EXCEL_TYPE_DOCUMENTS = [
    DocumentTypeEnum.ENTREGA_ENTRADA,
]

export const DOCUMENT_TYPE_LABELS: Record<DocumentTypeEnum, string> = {
  [DocumentTypeEnum.COTIZACION]: 'Cotización',
  [DocumentTypeEnum.PEDIDO]: 'Pedido',
  [DocumentTypeEnum.DOCUMENTO_DE_CARGA]: 'Documento de carga',
  [DocumentTypeEnum.ENTREGA_ENTRADA]: 'Entrega entrada',
  [DocumentTypeEnum.FACTURA]: 'Factura',
  [DocumentTypeEnum.NOTA_DE_CREDITO]: 'Nota de crédito',
  [DocumentTypeEnum.NOTA_DE_DEBITO]: 'Nota de débito',
  [DocumentTypeEnum.DOCUMENTO_DE_PAGO]: 'Documento de pago',
  [DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO]: 'Solicitud cambio producto',
  [DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO]: 'Solicitud devolución producto',
  [DocumentTypeEnum.ENTREGA_SALIDA]: 'Entrega salida',
  [DocumentTypeEnum.CAMBIO_DE_PRODUCTO]: 'Cambio de producto',
  [DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO]: 'Devolución de producto',
  [DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE]: 'Documento de transporte',
  [DocumentTypeEnum.PEDIDO_DE_VENDEDOR]: 'Pedido de vendedor',
  [DocumentTypeEnum.LIQUIDACION]: 'Liquidación',
  [DocumentTypeEnum.DOCUMENTO_MERMA]: 'Documento merma'
};

export const DOCUMENT_TYPE_COLORS: Record<DocumentTypeEnum, string> = {
  [DocumentTypeEnum.COTIZACION]: 'green',
  [DocumentTypeEnum.PEDIDO]: 'blue',
  [DocumentTypeEnum.DOCUMENTO_DE_CARGA]: 'purple',
  [DocumentTypeEnum.ENTREGA_ENTRADA]: 'orange',
  [DocumentTypeEnum.FACTURA]: 'red',
  [DocumentTypeEnum.NOTA_DE_CREDITO]: 'yellow',
  [DocumentTypeEnum.NOTA_DE_DEBITO]: 'indigo',
  [DocumentTypeEnum.DOCUMENTO_DE_PAGO]: 'gray',
  [DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO]: 'green',
  [DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO]: 'red',
  [DocumentTypeEnum.ENTREGA_SALIDA]: 'blue',
  [DocumentTypeEnum.CAMBIO_DE_PRODUCTO]: 'purple',
  [DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO]: 'orange',
  [DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE]: 'yellow',
  [DocumentTypeEnum.PEDIDO_DE_VENDEDOR]: 'green',
  [DocumentTypeEnum.LIQUIDACION]: 'blue',
  [DocumentTypeEnum.DOCUMENTO_MERMA]: 'red'
};